import { jsx as r, jsxs as n } from "react/jsx-runtime";
import { DetailLabel as m } from "@strata/react-label-value-pairs";
import { TrendingIcon as a } from "@strata/react-status-icons";
import { formatPercentageString as c, addCommas as p } from "@strata/helper-functions";
import { DollarAmount as S } from "@strata/react-dollar-amount";
import "./main.scss";
const t = {
  DOLLARS: "$",
  PERCENTAGE: "%",
  SECONDS: "s",
  MINUTES: "m",
  DAYS: "d"
}, _ = (e, i) => {
  var s;
  return i === t.DOLLARS ? /* @__PURE__ */ r(S, { amount: e, showZeroValue: !0, large: !0 }) : i === t.PERCENTAGE ? ((s = c(e, 2, 2)) == null ? void 0 : s.replace("%", "")) ?? "--" : e != null && !i && Number.isNaN(Number(e)) ? e : p(e) ?? "--";
}, d = ({
  value: e = void 0,
  label: i,
  valueType: s = void 0,
  trendingIndicator: l = void 0
}) => /* @__PURE__ */ n("div", { className: "sds_kpi", children: [
  /* @__PURE__ */ r("span", { className: "sds_kpi__value sds_kpi__value--large", children: _(e, s) }),
  s && s !== t.DOLLARS && /* @__PURE__ */ r("span", { className: "sds_kpi__value sds_kpi__value-type--large padding__left--x-small", children: s }),
  /* @__PURE__ */ n("div", { style: { display: "flex" }, children: [
    /* @__PURE__ */ r("span", { className: "padding__right--x-small", children: /* @__PURE__ */ r(m, { label: i }) }),
    l && /* @__PURE__ */ r(
      a,
      {
        trendDirection: l.trendDirection,
        trendState: l.trendState
      }
    )
  ] })
] });
d.ValueTypes = t;
d.TrendStates = a.States;
d.TrendDirections = a.Directions;
const o = ({
  value: e = void 0,
  valueType: i = void 0,
  trendingIndicator: s = void 0
}) => /* @__PURE__ */ r("div", { className: "sds_kpi__container padding__around--x-small", children: /* @__PURE__ */ n(
  "div",
  {
    className: "sds_kpi sds_kpi--small",
    style: { display: "flex", alignItems: "center", justifyContent: "center" },
    children: [
      /* @__PURE__ */ r("span", { className: "sds_kpi__value sds_kpi__value--small", children: _(e, i) }),
      i && i !== t.DOLLARS && /* @__PURE__ */ r("span", { className: "sds_kpi__value sds_kpi__value-type--small", children: i }),
      s && /* @__PURE__ */ r(
        a,
        {
          trendDirection: s.trendDirection,
          trendState: s.trendState
        }
      )
    ]
  }
) });
o.ValueTypes = t;
o.TrendStates = a.States;
o.TrendDirections = a.Directions;
export {
  d as KpiLarge,
  o as KpiSmall
};
//# sourceMappingURL=index.js.map
